import { useEffect } from 'react';

const LightEffects = () => {
  useEffect(() => {
    // Cursor takip eden ışık efekti
    const cursorLight = document.createElement('div');
    cursorLight.className = 'cursor-light';
    cursorLight.style.cssText = `
      position: fixed;
      width: 400px;
      height: 400px;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(212,175,55,0.15) 0%, rgba(212,175,55,0.05) 40%, transparent 70%);
      pointer-events: none;
      z-index: 9999;
      transform: translate(-50%, -50%);
      transition: opacity 0.3s ease;
      mix-blend-mode: screen;
    `;
    document.body.appendChild(cursorLight);

    let mouseX = 0;
    let mouseY = 0;
    let cursorX = 0;
    let cursorY = 0;

    const handleMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const animate = () => {
      cursorX += (mouseX - cursorX) * 0.1;
      cursorY += (mouseY - cursorY) * 0.1;
      cursorLight.style.left = cursorX + 'px';
      cursorLight.style.top = cursorY + 'px';
      requestAnimationFrame(animate);
    };

    document.addEventListener('mousemove', handleMouseMove);
    animate();

    // Parçacık efektleri
    const createParticle = () => {
      const particle = document.createElement('div');
      particle.className = 'particle';
      const size = Math.random() * 5 + 3;
      const startX = Math.random() * window.innerWidth;
      const startY = Math.random() * window.innerHeight;
      const duration = Math.random() * 20 + 10;
      const delay = Math.random() * 5;

      particle.style.cssText = `
        position: fixed;
        width: ${size}px;
        height: ${size}px;
        background: radial-gradient(circle, rgba(212,175,55,0.9) 0%, rgba(212,175,55,0.4) 50%, rgba(212,175,55,0.1) 100%);
        border-radius: 50%;
        pointer-events: none;
        z-index: 1;
        left: ${startX}px;
        top: ${startY}px;
        box-shadow: 0 0 ${size * 3}px rgba(212,175,55,0.8), 0 0 ${size * 5}px rgba(212,175,55,0.4);
        animation: float ${duration}s ${delay}s infinite ease-in-out;
      `;

      document.body.appendChild(particle);

      setTimeout(() => {
        particle.remove();
      }, (duration + delay) * 1000);
    };

    // Her 1 saniyede bir parçacık oluştur (daha sık)
    const particleInterval = setInterval(createParticle, 1000);
    // Başlangıçta daha fazla parçacık oluştur
    for (let i = 0; i < 25; i++) {
      setTimeout(createParticle, i * 150);
    }

    // Gradient animasyonu için CSS ekle
    const style = document.createElement('style');
    style.textContent = `
      @keyframes float {
        0%, 100% {
          transform: translate(0, 0) scale(1);
          opacity: 0.5;
        }
        25% {
          transform: translate(20px, -30px) scale(1.2);
          opacity: 0.8;
        }
        50% {
          transform: translate(-15px, -50px) scale(0.8);
          opacity: 0.6;
        }
        75% {
          transform: translate(30px, -20px) scale(1.1);
          opacity: 0.7;
        }
      }

      @keyframes shimmer {
        0% {
          background-position: -1000px 0;
        }
        100% {
          background-position: 1000px 0;
        }
      }

      .shimmer-effect {
        background: linear-gradient(
          90deg,
          transparent 0%,
          rgba(212,175,55,0.1) 50%,
          transparent 100%
        );
        background-size: 1000px 100%;
        animation: shimmer 3s infinite;
      }

      /* Hover glow efektleri */
      .premium-glow {
        position: relative;
        transition: all 0.3s ease;
      }

      .premium-glow::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: linear-gradient(45deg, rgba(212,175,55,0.5), rgba(251,191,36,0.5), rgba(212,175,55,0.5));
        border-radius: inherit;
        z-index: -1;
        opacity: 0;
        filter: blur(10px);
        transition: opacity 0.3s ease;
      }

      .premium-glow:hover::before {
        opacity: 1;
      }

      /* Scroll glow efekti */
      @keyframes scrollGlow {
        0%, 100% {
          box-shadow: 0 0 20px rgba(212,175,55,0.3);
        }
        50% {
          box-shadow: 0 0 40px rgba(212,175,55,0.6);
        }
      }

      .scroll-glow {
        animation: scrollGlow 3s ease-in-out infinite;
      }
    `;
    document.head.appendChild(style);

    // Scroll animasyonları
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    // Tüm kartlara scroll animasyonu ekle (sadece public sayfalarda)
    if (!window.location.pathname.includes('/admin')) {
      const cards = document.querySelectorAll('.premium-card, .bg-gradient-to-br');
      cards.forEach(card => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(30px)';
        card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(card);
      });
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      clearInterval(particleInterval);
      cursorLight.remove();
      style.remove();
      observer.disconnect();
    };
  }, []);

  return null;
};

export default LightEffects;
